var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 750,
    viewBox: "0 0 430 750",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.477 747.966C294.237 750.769 260.8 750.24 227.668 746.387C172.226 740.02 117.981 724.848 66.2484 702.993C-107.246 629.651 -252.507 481.007 -320.411 336.748C-329.306 317.944 -337.025 298.606 -343.522 278.845C-350.292 258.396 -355.307 237.407 -358.513 216.106C-362.389 189.544 -362.936 162.366 -358.531 135.897C-351.184 91.7887 -331.38 57.5306 -304.854 34.5782C-290.685 22.2725 -274.158 12.9827 -256.28 7.27623C-238.403 1.5698 -219.551 -0.433599 -200.875 1.38854C-175.359 3.75346 -149.473 12.9322 -125.32 29.6272C-112.7 38.1529 -101.243 48.2844 -91.2393 59.7667C-16.7853 146.787 -120.522 220.031 -45.9429 294.838C46.0105 387.133 188.015 237.76 294.102 232.56C352.163 229.713 416.364 236.896 489.703 296.765C493.461 299.827 497.106 302.973 500.639 306.201C551.353 352.441 572.601 399.379 582.914 446.871C592.798 492.672 588.204 540.417 569.766 583.503C552.989 623.237 525.203 659.178 488.534 687.35C463.191 706.72 434.834 721.789 404.599 731.952C379.633 740.388 353.737 745.765 327.477 747.966Z",
    fill: "url(#paint0_linear_1_3753)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3753",
    x1: 381.21,
    y1: 28.8488,
    x2: 168.578,
    y2: 475.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B67CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DC3EE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector15);
export default __webpack_public_path__ + "static/media/vector15.c55e7774ef92468a5406ff8d53dd337b.svg";
export { ForwardRef as ReactComponent };